import { GET_CAPPING_LIMIT, LIMIT_UPDATED } from './LimitConstants';

import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../async/asyncActions';

import API from '../../APIconfig';

export const getCappingLimitsForUser = (csrfRequestIdentifier) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Getting transaction limits...', true, 'getLimit'));
      const reqObject = {
        method: API.bank.getCappingLimitsForUser.method,
        credentials: 'include',
        mode: 'cors',
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
        }),
      };

      const limit = await fetch(API.bank.getCappingLimitsForUser.url, reqObject).then(response => response.json());

      dispatch({
        type: GET_CAPPING_LIMIT,
        payload: limit,
      });

      dispatch(asyncActionFinish());

    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
}

export const limitUpdated = (payload) =>  {
  return {
    type: LIMIT_UPDATED,
    payload,
  }
};